var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"title",rawName:"v-title"}],attrs:{"id":"app","data-title":_vm.$appName + '系统'}},[_c('router-view'),_c('DynamicIsland')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }